// extracted by mini-css-extract-plugin
export var eyebrow = "_kg-3";
export var heroImage = "_kg-4";
export var main = "_kg-2";
export var modal = "_kg-0";
export var shell = "_kg-1";